import type { State } from '../../types';

export function hasOrganizationNotPending(state: State): boolean {
  return state.organization !== undefined && !state.organization.pending;
}
